// Generated by purs version 0.13.8
"use strict";
var $foreign = require("./foreign.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_Except = require("../Control.Monad.Except/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Semiring = require("../Data.Semiring/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Traversable = require("../Data.Traversable/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Effect = require("../Effect/index.js");
var Effect_Exception = require("../Effect.Exception/index.js");
var Foreign = require("../Foreign/index.js");
var Foreign_Class = require("../Foreign.Class/index.js");
var JQuery = require("../JQuery/index.js");
var Restaumatic_Holiday = require("../Restaumatic.Holiday/index.js");
var Restaumatic_I18n = require("../Restaumatic.I18n/index.js");
var Restaumatic_Site_Translations_Keys = require("../Restaumatic.Site.Translations.Keys/index.js");
var Utils_Elm = require("../Utils.Elm/index.js");
var Utils_JQuery = require("../Utils.JQuery/index.js");
var safeView = function (element) {
    return function (state) {
        return function (dispatch) {
            var swapClasses = function (elem) {
                return function (add) {
                    return function (remove) {
                        return function __do() {
                            JQuery.addClass(add)(elem)();
                            return JQuery.removeClass(remove)(elem)();
                        };
                    };
                };
            };
            var popoverView = function (popover) {
                return function (makeActive) {
                    return function (title) {
                        return function (desc) {
                            return function (info) {
                                return function __do() {
                                    var popoverTitle = JQuery.find(".js-restaurant-hours-popover-title")(popover)();
                                    var popoverDetails = JQuery.find(".js-restaurant-hours-popover-details")(popover)();
                                    var popoverInfo = JQuery.find(".js-restaurant-hours-popover-info")(popover)();
                                    JQuery.setHtml(title)(popoverTitle)();
                                    JQuery.setHtml(desc)(popoverDetails)();
                                    JQuery.setHtml(info)(popoverInfo)();
                                    return Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableArray)([ popoverTitle, popoverDetails, popoverInfo ])(function (x) {
                                        if (makeActive) {
                                            return swapClasses(x)("text-success")("text-danger");
                                        };
                                        return swapClasses(x)("text-danger")("text-success");
                                    })();
                                };
                            };
                        };
                    };
                };
            };
            var onCollapseShow = function (ev) {
                return function __do() {
                    var target = JQuery.getTarget(ev)();
                    var targetRoot = JQuery.closest(".js-restaurant-hours")(target)();
                    var presentDay = JQuery.find(".js-restaurant-hours-present-day")(targetRoot)();
                    var presentDayHeader = JQuery.find(".js-restaurant-hours-header")(presentDay)();
                    var presentDayData = JQuery.find(".js-restaurant-hours-data")(presentDay)();
                    var presentDayBtnPopover = JQuery.find(".js-restaurant-hours-btn-popover")(presentDay)();
                    var presentDayNow = JQuery.find(".js-restaurant-hours-now")(presentDay)();
                    var collapseBtn = JQuery.find(".js-restaurant-hours-btn-collapse")(presentDay)();
                    var caretUp = JQuery.find(".js-icon-caret-up")(collapseBtn)();
                    var caretDown = JQuery.find(".js-icon-caret-down")(collapseBtn)();
                    JQuery.addClass("invisible")(presentDayHeader)();
                    JQuery.addClass("invisible")(presentDayData)();
                    JQuery.addClass("invisible")(presentDayBtnPopover)();
                    JQuery.addClass("invisible")(presentDayNow)();
                    Utils_JQuery.hide(caretDown)();
                    return Utils_JQuery.show(caretUp)();
                };
            };
            var onCollapseHide = function (ev) {
                return function __do() {
                    var target = JQuery.getTarget(ev)();
                    var targetRoot = JQuery.closest(".js-restaurant-hours")(target)();
                    var presentDay = JQuery.find(".js-restaurant-hours-present-day")(targetRoot)();
                    var presentDayHeader = JQuery.find(".js-restaurant-hours-header")(presentDay)();
                    var presentDayData = JQuery.find(".js-restaurant-hours-data")(presentDay)();
                    var presentDayBtnPopover = JQuery.find(".js-restaurant-hours-btn-popover")(presentDay)();
                    var presentDayNow = JQuery.find(".js-restaurant-hours-now")(presentDay)();
                    var collapseBtn = JQuery.find(".js-restaurant-hours-btn-collapse")(presentDay)();
                    var caretUp = JQuery.find(".js-icon-caret-up")(collapseBtn)();
                    var caretDown = JQuery.find(".js-icon-caret-down")(collapseBtn)();
                    JQuery.removeClass("invisible")(presentDayHeader)();
                    JQuery.removeClass("invisible")(presentDayData)();
                    JQuery.removeClass("invisible")(presentDayBtnPopover)();
                    JQuery.removeClass("invisible")(presentDayNow)();
                    Utils_JQuery.hide(caretUp)();
                    return Utils_JQuery.show(caretDown)();
                };
            };
            var hoursViewNow = function (elem) {
                return function (makeActive) {
                    return function __do() {
                        var isActive = JQuery.find(".js-restaurant-hours-is-active")(elem)();
                        var isInactive = JQuery.find(".js-restaurant-hours-is-inactive")(elem)();
                        (function () {
                            if (makeActive) {
                                return Utils_JQuery.show(isActive)();
                            };
                            return Utils_JQuery.hide(isActive)();
                        })();
                        if (makeActive) {
                            return Utils_JQuery.hide(isInactive)();
                        };
                        return Utils_JQuery.show(isInactive)();
                    };
                };
            };
            var getHolidayConfig = function (elem) {
                return function __do() {
                    var holidayConfig = Utils_JQuery.getData("widget-config")(elem)();
                    var v = Control_Monad_Except.runExcept(Foreign_Class.decode(Foreign_Class.recordDecode()(Foreign_Class.decodeFieldsCons(new Data_Symbol.IsSymbol(function () {
                        return "modifierClasses";
                    }))(Foreign_Class.stringDecode)(Foreign_Class.decodeFieldsNil)()()))(holidayConfig));
                    if (v instanceof Data_Either.Left) {
                        var decodingErrors = Data_Foldable.foldMap(Data_List_Types.foldableNonEmptyList)(Data_Monoid.monoidString)(Foreign.renderForeignError)(v.value0);
                        var errMsg = "Element doesn't have the property data-widget-config set correctly, current value: " + (Foreign.unsafeFromForeign(holidayConfig) + ("Errors: " + decodingErrors));
                        Utils_JQuery.logErrorOnElement(errMsg)(elem)();
                        return {
                            modifierClasses: ""
                        };
                    };
                    if (v instanceof Data_Either.Right) {
                        return v.value0;
                    };
                    throw new Error("Failed pattern match at Components.RestaurantHoursPS (line 170, column 7 - line 178, column 30): " + [ v.constructor.name ]);
                };
            };
            var upcomingHolidaysWidget = function (elem) {
                return function (upcomingHolidays) {
                    return function (v) {
                        return function __do() {
                            var content = JQuery.find(".js-upcoming-holidays-content")(elem)();
                            var $14 = Utils_JQuery.exists(content);
                            if ($14) {
                                var wrapper = Utils_JQuery.parents(".js-upcoming-holidays-wrapper")(content)();
                                var config = getHolidayConfig(wrapper)();
                                var $15 = Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt)(upcomingHolidays) === 0;
                                if ($15) {
                                    return Utils_JQuery.hide(wrapper)();
                                };
                                Utils_JQuery.show(wrapper)();
                                return Restaumatic_Holiday.view(config)(content)(upcomingHolidays)(dispatch)();
                            };
                            return Data_Unit.unit;
                        };
                    };
                };
            };
            var getDayIndex = function (el) {
                return function __do() {
                    var dayIndex = Utils_JQuery.getData("day")(el)();
                    var v = Control_Monad_Except.runExcept(Foreign.readInt(dayIndex));
                    if (v instanceof Data_Either.Left) {
                        return 0;
                    };
                    if (v instanceof Data_Either.Right) {
                        return v.value0;
                    };
                    throw new Error("Failed pattern match at Components.RestaurantHoursPS (line 157, column 7 - line 159, column 42): " + [ v.constructor.name ]);
                };
            };
            var getDataString = function (elem) {
                return function (classesType) {
                    return function __do() {
                        var classesData = Utils_JQuery.getData(classesType)(elem)();
                        var v = Control_Monad_Except.runExcept(Foreign.readString(classesData));
                        if (v instanceof Data_Either.Left) {
                            return "";
                        };
                        if (v instanceof Data_Either.Right) {
                            return v.value0;
                        };
                        throw new Error("Failed pattern match at Components.RestaurantHoursPS (line 183, column 7 - line 185, column 30): " + [ v.constructor.name ]);
                    };
                };
            };
            var findByClassIncludeSelf = function (className) {
                return function (elem) {
                    return function __do() {
                        var children = JQuery.find(className)(elem)();
                        var childrenWithRoot = Utils_JQuery.addBack(children)();
                        return Control_Bind.bind(Effect.bindEffect)(Utils_JQuery.filter(className)(childrenWithRoot))(Control_Applicative.pure(Effect.applicativeEffect))();
                    };
                };
            };
            var hoursViewAllDays = function (elem) {
                return function __do() {
                    var allDaysWrapper = findByClassIncludeSelf(".js-restaurant-hours-all-days")(elem)();
                    var days = JQuery.find(".js-restaurant-hours-day")(allDaysWrapper)();
                    var daysArr = JQuery.toArray(days)();
                    return Effect.foreachE(daysArr)(function (x) {
                        return function __do() {
                            var otherDaysPopoverBtn = JQuery.find(".js-restaurant-hours-btn-popover")(x)();
                            var otherDaysNow = JQuery.find(".js-restaurant-hours-now")(x)();
                            Utils_JQuery.hide(otherDaysPopoverBtn)();
                            return Utils_JQuery.hide(otherDaysNow)();
                        };
                    })();
                };
            };
            var hoursViewPresentDay = function (elem) {
                return function (makeActive) {
                    return function (dayHours) {
                        return function __do() {
                            var activeClasses = getDataString(elem)("active-classes")();
                            var inactiveClasses = getDataString(elem)("inactive-classes")();
                            var presentDayWrapper = findByClassIncludeSelf(".js-restaurant-hours-present-day")(elem)();
                            var presentDayData = JQuery.find(".js-restaurant-hours-data")(presentDayWrapper)();
                            JQuery.setHtml(dayHours)(presentDayData)();
                            if (makeActive) {
                                return swapClasses(presentDayWrapper)(activeClasses)(inactiveClasses)();
                            };
                            return swapClasses(presentDayWrapper)(inactiveClasses)(activeClasses)();
                        };
                    };
                };
            };
            var hoursViewToday = function (elem) {
                return function (makeActive) {
                    return function (dayIndex) {
                        return function __do() {
                            var activeClasses = getDataString(elem)("active-classes")();
                            var inactiveClasses = getDataString(elem)("inactive-classes")();
                            var allDaysWrapper = findByClassIncludeSelf(".js-restaurant-hours-all-days")(elem)();
                            var days = JQuery.find(".js-restaurant-hours-day")(allDaysWrapper)();
                            var daysArr = JQuery.toArray(days)();
                            var todayElems = Data_Array.filterA(Effect.applicativeEffect)(function (x) {
                                return function __do() {
                                    var day = Utils_JQuery.getData("day")(x)();
                                    var v = Control_Monad_Except.runExcept(Foreign.readInt(day));
                                    if (v instanceof Data_Either.Left) {
                                        return false;
                                    };
                                    if (v instanceof Data_Either.Right) {
                                        return v.value0 === dayIndex;
                                    };
                                    throw new Error("Failed pattern match at Components.RestaurantHoursPS (line 225, column 9 - line 227, column 58): " + [ v.constructor.name ]);
                                };
                            })(daysArr)();
                            var v = Data_Array.head(todayElems);
                            if (v instanceof Data_Maybe.Just) {
                                var todayPopoverBtn = JQuery.find(".js-restaurant-hours-btn-popover")(v.value0)();
                                var todayNow = JQuery.find(".js-restaurant-hours-now")(v.value0)();
                                Utils_JQuery.show(todayPopoverBtn)();
                                Utils_JQuery.show(todayNow)();
                                if (makeActive) {
                                    return swapClasses(v.value0)(activeClasses)(inactiveClasses)();
                                };
                                return swapClasses(v.value0)(inactiveClasses)(activeClasses)();
                            };
                            if (v instanceof Data_Maybe.Nothing) {
                                return Data_Unit.unit;
                            };
                            throw new Error("Failed pattern match at Components.RestaurantHoursPS (line 229, column 7 - line 237, column 29): " + [ v.constructor.name ]);
                        };
                    };
                };
            };
            var onlineHoursView = function (elem) {
                return function (av) {
                    return function __do() {
                        hoursViewNow(elem)(av.isOnlinePossible)();
                        hoursViewPresentDay(elem)(av.isOnlinePossible)(av.onlineHoursString)();
                        hoursViewAllDays(elem)();
                        hoursViewToday(elem)(av.isOnlinePossible)(av.onlineDayIndex)();
                        var popover = JQuery.find(".js-restaurant-hours-popover")(elem)();
                        var title = (function () {
                            if (av.isOnlinePossible) {
                                return Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.restaurants.hours.active);
                            };
                            return Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.restaurants.hours.inactive);
                        })();
                        var desc = (function () {
                            var $30 = av.holidaysHoursString === "";
                            if ($30) {
                                return "";
                            };
                            return Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.restaurants.hours.holidays) + (": " + av.holidaysHoursString);
                        })();
                        return popoverView(popover)(av.isOnlinePossible)(title)(desc)(av.holidaysInfo)();
                    };
                };
            };
            var openingHoursView = function (elem) {
                return function (av) {
                    return function __do() {
                        hoursViewNow(elem)(av.isRestaurantOpen)();
                        hoursViewPresentDay(elem)(av.isRestaurantOpen)(av.openingHoursString)();
                        hoursViewAllDays(elem)();
                        hoursViewToday(elem)(av.isRestaurantOpen)(av.openingDayIndex)();
                        var popover = JQuery.find(".js-restaurant-hours-popover")(elem)();
                        var title = (function () {
                            if (av.isRestaurantOpen) {
                                return Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.restaurants.hours.open);
                            };
                            return Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.restaurants.hours.closed);
                        })();
                        var desc = (function () {
                            var $32 = av.holidaysHoursString === "";
                            if ($32) {
                                return "";
                            };
                            return Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.restaurants.hours.holidays) + (": " + av.holidaysHoursString);
                        })();
                        return popoverView(popover)(av.isRestaurantOpen)(title)(desc)(av.holidaysInfo)();
                    };
                };
            };
            return function __do() {
                var elementsArr = JQuery.toArray(element)();
                Utils_Elm.onInit(element)(function __do() {
                    var body = JQuery.select("body")();
                    JQuery.on("show.bs.collapse")(function (ev) {
                        return function (el) {
                            return onCollapseShow(ev);
                        };
                    })(body)();
                    JQuery.on("hide.bs.collapse")(function (ev) {
                        return function (el) {
                            return onCollapseHide(ev);
                        };
                    })(body)();
                    var slugs = Data_Traversable.traverse(Data_Traversable.traversableArray)(Effect.applicativeEffect)(function (el) {
                        return Control_Bind.bind(Effect.bindEffect)(Utils_JQuery.getAttr("data-restaurant-slug")(el))(Control_Applicative.pure(Effect.applicativeEffect));
                    })(elementsArr)();
                    var slugsUniq = Data_Array.filterA(Effect.applicativeEffect)(function (x) {
                        return Control_Applicative.pure(Effect.applicativeEffect)(!(x === ""));
                    })(Data_Array.nub(Data_Ord.ordString)(slugs))();
                    return JQuery.ready(Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableArray)(slugsUniq)(function (slug) {
                        return dispatch({
                            type: "GET_RESTAURANT_HOURS",
                            payload: {
                                slug: slug
                            }
                        });
                    }))();
                })();
                return Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableArray)(elementsArr)(function (elem) {
                    return function __do() {
                        var slug = Utils_JQuery.getAttr("data-restaurant-slug")(elem)();
                        var v = Data_Foldable.find(Data_Foldable.foldableArray)(function (x) {
                            return x.slug === slug;
                        })(state.restaurantsAvailability);
                        if (v instanceof Data_Maybe.Just) {
                            var openingHoursWrapper = findByClassIncludeSelf(".js-restaurant-hours-opening")(elem)();
                            openingHoursView(openingHoursWrapper)(v.value0)();
                            var onlineHoursWrapper = findByClassIncludeSelf(".js-restaurant-hours-online")(elem)();
                            onlineHoursView(onlineHoursWrapper)(v.value0)();
                            return upcomingHolidaysWidget(elem)(v.value0.upcomingHolidays)(dispatch)();
                        };
                        if (v instanceof Data_Maybe.Nothing) {
                            return Data_Unit.unit;
                        };
                        throw new Error("Failed pattern match at Components.RestaurantHoursPS (line 59, column 5 - line 67, column 27): " + [ v.constructor.name ]);
                    };
                })();
            };
        };
    };
};
var view = function (element) {
    return function (fstate) {
        return function (dispatch) {
            var v = Control_Monad_Except.runExcept(Foreign_Class.decode(Foreign_Class.recordDecode()(Foreign_Class.decodeFieldsCons(new Data_Symbol.IsSymbol(function () {
                return "restaurantsAvailability";
            }))(Foreign_Class.arrayDecode(Foreign_Class.recordDecode()(Foreign_Class.decodeFieldsCons(new Data_Symbol.IsSymbol(function () {
                return "holidaysHoursString";
            }))(Foreign_Class.stringDecode)(Foreign_Class.decodeFieldsCons(new Data_Symbol.IsSymbol(function () {
                return "holidaysInfo";
            }))(Foreign_Class.stringDecode)(Foreign_Class.decodeFieldsCons(new Data_Symbol.IsSymbol(function () {
                return "isOnlinePossible";
            }))(Foreign_Class.booleanDecode)(Foreign_Class.decodeFieldsCons(new Data_Symbol.IsSymbol(function () {
                return "isPhonePossible";
            }))(Foreign_Class.booleanDecode)(Foreign_Class.decodeFieldsCons(new Data_Symbol.IsSymbol(function () {
                return "isRestaurantOpen";
            }))(Foreign_Class.booleanDecode)(Foreign_Class.decodeFieldsCons(new Data_Symbol.IsSymbol(function () {
                return "onlineDayIndex";
            }))(Foreign_Class.intDecode)(Foreign_Class.decodeFieldsCons(new Data_Symbol.IsSymbol(function () {
                return "onlineHoursString";
            }))(Foreign_Class.stringDecode)(Foreign_Class.decodeFieldsCons(new Data_Symbol.IsSymbol(function () {
                return "openingDayIndex";
            }))(Foreign_Class.intDecode)(Foreign_Class.decodeFieldsCons(new Data_Symbol.IsSymbol(function () {
                return "openingHoursString";
            }))(Foreign_Class.stringDecode)(Foreign_Class.decodeFieldsCons(new Data_Symbol.IsSymbol(function () {
                return "phoneDayIndex";
            }))(Foreign_Class.intDecode)(Foreign_Class.decodeFieldsCons(new Data_Symbol.IsSymbol(function () {
                return "phoneHoursString";
            }))(Foreign_Class.stringDecode)(Foreign_Class.decodeFieldsCons(new Data_Symbol.IsSymbol(function () {
                return "slug";
            }))(Foreign_Class.stringDecode)(Foreign_Class.decodeFieldsCons(new Data_Symbol.IsSymbol(function () {
                return "upcomingHolidays";
            }))(Foreign_Class.arrayDecode(Foreign_Class.recordDecode()(Foreign_Class.decodeFieldsCons(new Data_Symbol.IsSymbol(function () {
                return "description";
            }))(Foreign_Class.stringDecode)(Foreign_Class.decodeFieldsCons(new Data_Symbol.IsSymbol(function () {
                return "duration";
            }))(Foreign_Class.stringDecode)(Foreign_Class.decodeFieldsCons(new Data_Symbol.IsSymbol(function () {
                return "info";
            }))(Foreign_Class.stringDecode)(Foreign_Class.decodeFieldsNil)()())()())()())))(Foreign_Class.decodeFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())))(Foreign_Class.decodeFieldsNil)()()))(fstate));
            if (v instanceof Data_Either.Right) {
                return safeView(element)(v.value0)(dispatch);
            };
            if (v instanceof Data_Either.Left) {
                var decodingErrors = Data_Foldable.foldMap(Data_List_Types.foldableNonEmptyList)(Data_Monoid.monoidString)(Foreign.renderForeignError)(v.value0);
                var errMsg = "Incorrect data passed to RestaurantHours view, " + ("Errors: " + decodingErrors);
                return Effect_Exception["throw"](errMsg);
            };
            throw new Error("Failed pattern match at Components.RestaurantHoursPS (line 35, column 3 - line 41, column 19): " + [ v.constructor.name ]);
        };
    };
};
module.exports = {
    view: view,
    safeView: safeView,
    init: $foreign.init,
    update: $foreign.update
};
//# sourceMappingURL=index.js.map
